<wvr-dropdown-component
  [themeVariant]="'link'"
  [toggleOn]="'mouseover'"
  menuXOffset="{{menuXOffset}}px"
  [menuYOffset]="'-2px'"
  [menuWidth]="'928px'"
  [btnTextDecoration]="'none'"
  [btnColor]="'var(--tl-black)'"
  [btnFontWeight]="'bolder'"
  [btnColorHover]="'var(--tl-black)'"
  [btnTextDecorationHover]="'none'"
  [btnFontFamily]="'var(--tl-font-family-sans-serif)'"
  [ngClass]="{active: active}"
  [openDelay]="openDelay"
  ngbDropdownAnchor>
  <template dropdown-button>
    <span (click)="toggleMobileMenuOpen()">
      {{menuTitle}}
      <tl-icon-component
        class="x-icon"
        [hiddenInMobile]="true"
        [set]="'bootstrap'"
        [name]="'caret-right-fill'"
        [size]="'11px'">
      </tl-icon-component>
      <tl-icon-component
        class="plus-icon"
        [set]="'bootstrap'"
        [name]="'plus'"
        [size]="'24px'">
      </tl-icon-component>
    </span>
  </template>
  <template dropdown-menu>
    <div class="tl-mega-menu-custom-top" *ngIf="!isMobileLayout">
      <div class="flex-fill align-self-stretch">
        <ng-content select="tl-mega-menu-custom[top-content]"></ng-content>
      </div>
    </div>
    <div class="mega-menu-sections d-flex justify-content-between flex-wrap" *ngIf="!isMobileLayout">
      <ng-container *ngTemplateOutlet="sections"></ng-container>
    </div>
    <div class="tl-mega-menu-custom-bottom" *ngIf="!isMobileLayout">
      <div class="flex-fill align-self-stretch">
        <ng-content select="tl-mega-menu-custom[bottom-content]"></ng-content>
      </div>
    </div>
    <div class="mega-menu-view-all container pt-2" *ngIf="viewAllHref">
      <tl-button-component [href]="viewAllHref" [themeVariant]="'primary'">
        <template button-content>
          <wvr-text-component [value]="viewAllButtonDisplayText"></wvr-text-component>
        </template>
      </tl-button-component>
    </div>
  </template>
</wvr-dropdown-component>

<div *ngIf="isMobileLayout" class="mobile-display" [ngClass]="{active: active}">
  <ng-container *ngTemplateOutlet="sections"></ng-container>
  <tl-mega-menu-section [sectionTitle]="viewAllButtonDisplayText" [viewAllHref]="viewAllHref"></tl-mega-menu-section>
</div>

<ng-template #sections>
  <ng-content select="tl-mega-menu-section"></ng-content>
</ng-template>
